import { Box, IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FC, MouseEventHandler, ReactNode, useMemo } from 'react';
import { Loading } from '../loading/loading.component';
import { useBreakpoint } from '../../hooks/breakpoint.hook';
import { FormGrid } from '../form-grid/form-grid.component';

interface Props {
    children: ReactNode;
    title?: ReactNode;
    filter?: ReactNode;
    subTitle?: ReactNode;
    actions?: ReactNode | ReactNode[];
    onBack?: MouseEventHandler;
    loading?: boolean;
}

export const Page: FC<Props> = ({ actions, onBack, title, subTitle, filter, children, loading }) => {
    const md = useBreakpoint('md');

    const mappedActions = useMemo(() => (Array.isArray(actions) ? actions : [actions]), [actions]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: 'calc(100vh - 55px)',
                minWidth: 0,
                maxWidth: '100%',
            }}
        >
            {title && (
                <Stack
                    p={2}
                    gap={1}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    flexWrap="nowrap"
                    height="fit-content"
                    sx={{
                        borderBottom: '1px solid lightgrey',
                        backgroundColor: ({ palette }) => palette.background.paper,
                    }}
                >
                    <Stack
                        gap={1}
                        direction="row"
                        alignItems="center"
                        flexWrap="nowrap"
                        minHeight="50px"
                        minWidth={0}
                        sx={{ color: ({ palette }) => palette.grey[800] }}
                    >
                        {onBack && (
                            <IconButton aria-label="back button" onClick={onBack} size="large">
                                <ArrowBackIcon />
                            </IconButton>
                        )}

                        <Typography variant="subtitle1">{title}</Typography>

                        {subTitle && <Typography variant="subtitle2">{subTitle}</Typography>}

                        {filter}
                    </Stack>

                    {mappedActions && (
                        <FormGrid
                            containerProps={{
                                spacing: 1,
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                minWidth: 'fit-content',
                                flexShrink: 0,
                            }}
                        >
                            {mappedActions.map((action, index) => (
                                <Box key={index} sx={{ '.MuiInputBase-root input': { p: '8px' } }}>
                                    {action}
                                </Box>
                            ))}
                        </FormGrid>
                    )}
                </Stack>
            )}

            <Box sx={{ p: 2, flex: 1, overflowY: 'auto', mb: md ? 1 : 8 }}>{loading ? <Loading /> : children}</Box>
        </Box>
    );
};
